import Icons from './Icons';
import { cn } from '@/utils/cn';

interface ClickMissionProps {
  title: string;
  isWhite?: boolean;
}

const ClickMission: React.FC<ClickMissionProps> = ({ title, isWhite = false }: ClickMissionProps) => {
  const textColor = isWhite ? 'text-text-primary' : 'text-text-disabled';
  const Icon = isWhite ? Icons.ClickMissionWhite : Icons.ClickMission;

  return (
    <div className='flex flex-col items-center gap-1'>
      <Icon className={cn('w-[24px] lg:w-[32px] h-[24px] lg:h-[32px]', textColor)} />
      <span className={cn('text-lg lg:text-2xl italic text-center', textColor)}>{title}</span>
    </div>
  );
};

export default ClickMission;
